<template>
  <div class="editPassword">
    <van-cell-group>
      <van-cell>
        <template #title>
          <label for="input-current-pass">
            {{ $t("current password") }}
          </label>
        </template>
        <template #right-icon>
          <input
            id="input-current-pass"
            class="input-password"
            v-model="resetPassword.old_password"
            type="password"
          />
        </template>
      </van-cell>
      <van-cell>
        <template #title>
          <label for="input-new-pass">
            {{ $t("new password") }}
          </label>
        </template>
        <template #right-icon>
          <input
            id="input-new-pass"
            class="input-password"
            v-model="resetPassword.new_password1"
            type="password"
          />
        </template>
      </van-cell>
    </van-cell-group>
    <div class="saveActions">
      <van-button type="primary" @click="submitChangePassword">
        {{ $t("save") }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "EditProfile",
  computed: {
    ...mapState("account", ["user"])
  },
  data() {
    return {
      resetPassword: {
        new_password1: "",
        new_password2: "",
        old_password: ""
      }
    };
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("account", ["logout", "changePassword"]),
    submitChangePassword() {
      this.resetPassword.new_password2 = this.resetPassword.new_password1;
      this.changePassword(this.resetPassword);
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("edit password"));
  }
};
</script>

<style lang="scss">
.editPassword {
  padding: 15px;
  padding-top: 30px;
  .input-password {
    width: 65%;
    border: 0;
    text-align: right;

    &:active,
    &:hover {
      border-bottom: 1px solid #87d3f0;
    }
  }
  .saveActions {
    display: flex;
    justify-content: flex-end;
    padding: 15px;
  }
}
</style>
